export default __webpack_public_path__ + "static/media/about1.a2463e55.png";